import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64b37c4a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b37c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b37c4a')) {
      api.createRecord('64b37c4a', component.options)
    } else {
      api.reload('64b37c4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64b37c4a&scoped=true&", function () {
      api.rerender('64b37c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersales/orderList/index.vue"
export default component.exports